import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { LogoHeader } from '../../../containers/Components/index';

import instagram_square from '../../../assets/img/instagram-square.png';

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> FAQ </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> What is virtual reality?
                    </h6>
                    <h6>
                      <strong>A: </strong> Virtual Reality (VR) is the use of computer technology to create a simulated environment. 
                      Unlike traditional user interfaces, VR places the user inside an experience. Instead of viewing a screen in 
                      front of them, users are immersed and able to interact with 3D worlds. By simulating as many senses as possible, 
                      such as vision, hearing, touch, even smell, the computer is transformed into a gatekeeper to this artificial world. 
                      The only limits to near-real VR experiences are the availability of content and cheap computing power. 
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> What is augmented reality?
                    </h6>
                    <h6>
                      <strong>A: </strong> Augmented reality (AR) is an interactive experience of a real-world environment whereby 
                      the objects that reside in the real-world are "augmented" by computer-generated perceptual information, 
                      sometimes across multiple sensory modalities, including visual, auditory, haptic, somatosensory, 
                      and olfactory. The overlaid sensory information can be constructive (i.e. additive to the natural environment) 
                      or destructive (i.e. masking of the natural environment) and is seamlessly interwoven with the physical world 
                      such that it is perceived as an immersive aspect of the real environment. In this way, augmented reality alters 
                      one’s ongoing perception of a real world environment, whereas virtual reality completely replaces the user's 
                      real world environment with a simulated one.
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> What is 360 experience?
                    </h6>
                    <h6>
                      <strong>A: </strong> 360-degree experience (or 360-degree virtual reality) is an audiovisual simulation 
                      of an altered, augmented or substituted environment that surrounds the user, allowing them to look around 
                      them in all directions, just as they can in real life.
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> What are virtual reality headsets and how can I get one?
                    </h6>
                    <h6>
                      <strong>A: </strong> The main ingredient in virtual reality is a persistent 3D visual representation 
                      of the experience that conveys a sense of depth. To create this depth, virtual reality hardware systems 
                      employ a 3D display, also known as a stereoscopic display or head mounted display (HMD). Please refer to our 
                      <a target="_blank" rel="noopener noreferrer" href="http://www.icomputinglabs.in/blog/index.php/total-immersion-experience-vr-headsets/"> BLOG</a> to 
                      find the best VR headset for you. 
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> Is there a guide for the currently supported features and upcoming roadmap?
                    </h6>
                    <h6>
                      <strong>A: </strong> Yes. Please find the feature and roadmap guide <a href="/feature">here</a>.
                    </h6>
                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> How do I get the Competencies VR app for consuming off-the-self solutions?
                    </h6>
                    <h6>
                      <strong>A: </strong> Once you register your interest by buying the solution, we will send you the app.
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> I want to make a custom XR experience for my business. Can you help us?
                    </h6>
                    <h6>
                      <strong>A: </strong> Yes, sure. Our team of artists, managers and developers are always 
                      ready to help you. Please read <a href="/customdev">this</a> to understand our custom development process. 
                    </h6>
                  </Col>  
                </Row>

                {/* -------------- Footer Start -------- */}
                <Row className="mt-5">
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features & Roadmap</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >Solutions</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Professional Services</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/pricing"><div className = "font-size-10" >Pricing</div></a>
                      </Col>                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              {/* -------------- Footer End -------- */}
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/views/Pages/FAQ/FAQ.js